module.exports = __webpack_public_path__ + "img/img_4.77b8994d.webp";